<mat-sidenav-container hasBackdrop="false" style="height: 100%" [class]="appTheme">
  <mat-sidenav #sidenav *ngIf="!userSessionService.isSignedOut" mode="side" [disableClose]="true" opened="true"
    class="custom-sidenav side-menu">
    <app-side-nav></app-side-nav>
  </mat-sidenav>
  <mat-sidenav-content style="margin-left: 64px;">
    <app-header *ngIf="!userSessionService.isSignedOut"></app-header>
    <div class="page-content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>